// extracted by mini-css-extract-plugin
export default {"modalInner":"confirm_modal_modalInner__t+8By","modalText":"confirm_modal_modalText__idmmq","rowIcon":"confirm_modal_rowIcon__DzKBt"};